import { create } from 'zustand';
import { JKCContact, POI } from './utils/type';

interface StopTypeInfo {
  personPoint: POI;
  stopPoint: POI;
  contactList: JKCContact[];
}

interface TaskInfoState {
  load: StopTypeInfo;
  unload: StopTypeInfo;
  productType?: string;
}

interface TaskInfoStore {
  taskInfo: TaskInfoState;
  updateStopPointAndPersonPoint: (
    stopType: 'load' | 'unload',
    pointData: {
      stopPoint: POI;
      personPoint: POI;
    }
  ) => void;
  addContact: (stopType: 'load' | 'unload', contact: JKCContact) => void;
  deleteContact: (stopType: 'load' | 'unload', contact: JKCContact) => void;
  deleteContactsByUserIds: (
    contactUserIdList: Array<string | number>
  ) => void;
  setProductType: (productType: string) => void;
  resetTaskInfo: () => void;
}
const initPointData: POI = {
  id: '',
  title: '',
  address: '',
  source: '',
  cityCode: '',
  location: {
    latitude: '',
    longitude: ''
  }
};
const initData: TaskInfoState = {
  load: {
    personPoint: initPointData,
    stopPoint: initPointData,
    contactList: []
  },
  unload: {
    personPoint: initPointData,
    stopPoint: initPointData,
    contactList: []
  },
  productType: undefined
};
export const useTaskInfoStore = create<TaskInfoStore>((set) => ({
  taskInfo: initData,

  updateStopPointAndPersonPoint: (stopType, pointData) =>
    set((state) => ({
      taskInfo: {
        ...state.taskInfo,
        [stopType]: {
          ...state.taskInfo[stopType],
          stopPoint: pointData.stopPoint,
          personPoint: pointData.personPoint
        }
      }
    })),

  addContact: (stopType, contact) =>
    set((state) => {
      const currentContactList = state.taskInfo[stopType].contactList;

      if (!currentContactList.some((c) => c.userPhone === contact.userPhone)) {
        return {
          taskInfo: {
            ...state.taskInfo,
            [stopType]: {
              ...state.taskInfo[stopType],
              contactList: [...currentContactList, contact]
            }
          }
        };
      }
      return state;
    }),
  deleteContact: (stopType, contact) =>
    set((state) => ({
      taskInfo: {
        ...state.taskInfo,
        [stopType]: {
          ...state.taskInfo[stopType],
          contactList: state.taskInfo[stopType].contactList.filter(
            (c) => c.userPhone !== contact.userPhone
          )
        }
      }
    })),

  deleteContactsByUserIds: (contactUserIdList) =>
    set((state) => {
      const contactUserIdSet = new Set(contactUserIdList.map(String));
      const filterContacts = (contactList: JKCContact[]) =>
        contactList.filter(
          (contact) =>
            !contact.contactUserId ||
            !contactUserIdSet.has(String(contact.contactUserId))
        );

      return {
        taskInfo: {
          ...state.taskInfo,
          load: {
            ...state.taskInfo.load,
            contactList: filterContacts(state.taskInfo.load.contactList)
          },
          unload: {
            ...state.taskInfo.unload,
            contactList: filterContacts(state.taskInfo.unload.contactList)
          }
        }
      };
    }),

  setProductType: (productType) =>
    set((state) => ({
      taskInfo: { ...state.taskInfo, productType }
    })),

  resetTaskInfo: () =>
    set(() => ({
      taskInfo: initData
    }))
}));
